interface SuccessPanelProps {
  title: string;
  children?: React.ReactNode;
  onLogAnother: () => void;
  onHome: () => void;
  logAnotherLabel?: string;
}

export function SuccessPanel({
  title,
  children,
  onLogAnother,
  onHome,
  logAnotherLabel = 'Log Another',
}: SuccessPanelProps) {
  return (
    <div className="mx-auto max-w-lg px-4 py-8">
      <div className="rounded-lg bg-ndd-800 p-6 text-center">
        <h2 className="mb-2 text-2xl font-bold">{title}</h2>
        {children}
        <div className="mt-6 flex gap-3">
          <button
            type="button"
            onClick={onLogAnother}
            className="flex-1 rounded-lg bg-ndd-700 py-3 font-semibold hover:bg-ndd-600"
          >
            {logAnotherLabel}
          </button>
          <button
            type="button"
            onClick={onHome}
            className="flex-1 rounded-lg bg-ndd-900 py-3 font-semibold hover:bg-ndd-800"
          >
            Home
          </button>
        </div>
      </div>
    </div>
  );
}

interface MutationErrorProps {
  error: unknown;
  fallbackMessage: string;
}

export function MutationError({ error, fallbackMessage }: MutationErrorProps) {
  return (
    <div className="rounded-lg bg-red-900 p-3 text-red-200">
      {error instanceof Error ? error.message : fallbackMessage}
    </div>
  );
}

interface SubmitButtonProps {
  isPending: boolean;
  label?: string;
}

export function SubmitButton({ isPending, label = 'Submit' }: SubmitButtonProps) {
  return (
    <button
      type="submit"
      disabled={isPending}
      className="w-full rounded-lg bg-ndd-600 py-4 text-xl font-bold hover:bg-ndd-500 active:bg-ndd-400 disabled:opacity-50"
    >
      {isPending ? 'Submitting...' : label}
    </button>
  );
}
